import { render } from "./ControlPoint.vue?vue&type=template&id=ffff221e&scoped=true"
import script from "./ControlPoint.vue?vue&type=script&lang=js"
export * from "./ControlPoint.vue?vue&type=script&lang=js"

import "./ControlPoint.vue?vue&type=style&index=0&id=ffff221e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffff221e"]])

export default __exports__